import { AxiosError } from 'axios';
import { useTranslation } from 'next-i18next';

import { logger } from '@zep/core-logger';

import { HttpStatusCodeEnum } from '@/api';
import { alertDialog } from '@/ui_v3';

export const useBuildAiYoutubeErrorAlert = () => {
  const { t } = useTranslation(['build']);

  const handleAlert = (error: unknown) => {
    if (!(error instanceof AxiosError)) {
      alertDialog.open({
        header: {
          title: t('build:build.ai.youtube.generate.error.failed'),
        },
      });
      return;
    }

    switch (error.status) {
      case HttpStatusCodeEnum.BAD_REQUEST_400:
        alertDialog.open({
          header: {
            title: t('build:build.ai.youtube.generate.error.noSubtitles'),
          },
        });
        logger.track('ai_youtube_generate_error', {
          reason: 'NO_SUBTITLES',
        });
        break;
      case HttpStatusCodeEnum.INTERNAL_SERVER_ERROR_500:
        alertDialog.open({
          header: {
            title: t(
              'build:build.ai.youtube.generate.error.subtitlesLoadFailed',
            ),
          },
        });
        logger.track('ai_youtube_generate_error', {
          reason: 'SUBTITLES_LOAD_FAILED',
        });
        break;

      case undefined:
      default:
        alertDialog.open({
          header: {
            title: t('build:build.ai.youtube.generate.error.unknown'),
          },
        });
        logger.track('ai_youtube_generate_error', {
          reason: 'UNKNOWN_ERROR',
        });
        break;
    }
  };

  return handleAlert;
};
